import { ReactComponent as ArrowLeft } from '../../../assets/images/blueTheme/arrowLeft.svg';
import { ReactComponent as ArrowRight } from '../../../assets/images/blueTheme/arrowRight.svg';
import { MONTHS_ARRAY } from './constants';
import { StyledArrowWrapper, StyledDatePickerHeader, StyledSelectMonth, StyledSelectYear } from './styled';
import { SelectProps } from './utils';

type Props = {
  date: Date;
  changeYear: (year: number) => void;
  changeMonth: (month: number) => void;
  decreaseMonth: VoidFunction;
  increaseMonth: VoidFunction;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  yearArray: SelectProps[];
};

const DatePickerHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  yearArray,
}: Props): JSX.Element => (
  <StyledDatePickerHeader data-testid="customHeaderWrapper">
    <StyledArrowWrapper
      data-testid="arrowBack"
      onClick={(): void => {
        if (!prevMonthButtonDisabled) decreaseMonth();
      }}
      disabled={prevMonthButtonDisabled}
    >
      <ArrowLeft />
    </StyledArrowWrapper>

    <StyledSelectMonth
      dataTestId="selectMonth"
      options={MONTHS_ARRAY}
      value={MONTHS_ARRAY[date.getMonth()]}
      isClearable={false}
      onChange={(value): void => {
        if (value) changeMonth(MONTHS_ARRAY.indexOf(value));
      }}
    />

    <StyledSelectYear
      dataTestId="selectYear"
      options={yearArray}
      isClearable={false}
      value={{ value: String(date.getFullYear()), label: String(date.getFullYear()) }}
      onChange={(value): void => {
        changeYear(Number(value!.value));
      }}
    />

    <StyledArrowWrapper
      data-testid="arrowForward"
      onClick={(): void => {
        if (!nextMonthButtonDisabled) increaseMonth();
      }}
      disabled={nextMonthButtonDisabled}
    >
      <ArrowRight />
    </StyledArrowWrapper>
  </StyledDatePickerHeader>
);

export default DatePickerHeader;
